import * as React from 'react';

export interface IBlankNoteProps {
  blankFlag: boolean;
}

export interface IBlankNoteState {
}


export default class BlankNote extends React.Component<IBlankNoteProps, IBlankNoteState> {

  constructor(props: IBlankNoteProps) {
    super(props);
    this.state = {
    };
  }

  renderRows() {
    const result = [];
    for (let i = 0; i < 23; i += 1) {
      result.push(
        <hr key={i} />,
      );
    }
    return result;
  }

  render() {
    return (
      <div className="blank-note">
        <span className="blank-note-title">Notes</span>
        <div className="blank-note-box">
          {this.renderRows()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/common/BlankNote.tsx